module.exports = __webpack_public_path__ + "img/b-4.1dc2dc0.png";